import {
  Check,
  FilePen,
  FilePlus2,
  FileX2,
  Pencil,
  UserPlus,
  UserX,
  type LucideIcon,
} from 'lucide-react';
import type { ReactElement } from 'react';

import type { ActionLogKind } from '@/types';

const ICON_BY_KIND: Record<ActionLogKind, LucideIcon> = {
  'customer.created': UserPlus,
  'customer.updated': Pencil,
  'customer.archived': UserX,
  'visit.marked': Check,
  'membership.created': FilePlus2,
  'membership.updated': FilePen,
  'membership.archived': FileX2,
};

interface RenderOptions {
  size?: number;
}

export const renderActionLogIcon = (
  kind: ActionLogKind,
  { size = 16 }: RenderOptions = {}
): ReactElement => {
  const Icon = ICON_BY_KIND[kind];
  return <Icon size={size} strokeWidth={2} />;
};
